const toCamelCase = (str) => str.replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''));
/**
 * Recursively converts all object keys from kebab-case or snake_case to camelCase.
 * This function handles nested objects and arrays as well.
 *
 * @param obj - The object whose keys are to be converted. Can be an object, array, or any other type.
 * @returns The new object with its keys in camelCase. If the input is an array or a non-object,
 * it returns the input as is.
 *
 * @example
 * convertKeysToCamelCase({ 'example-key': 'value', nested_object: { 'another-key': 'value' } });
 * // Returns: { exampleKey: 'value', nestedObject: { anotherKey: 'value' } }
 */
const convertKeysToCamelCase = (obj) => {
    if (Array.isArray(obj)) {
        return obj.map((v) => convertKeysToCamelCase(v));
    }
    if (obj !== null && obj.constructor === Object) {
        return Object.keys(obj).reduce((result, key) => ({
            ...result,
            [toCamelCase(key)]: convertKeysToCamelCase(obj[key]),
        }), {});
    }
    return obj;
};

export { convertKeysToCamelCase, toCamelCase };
//# sourceMappingURL=dataTransforms.js.map
